<template>
  <v-col :cols="4">
    <div v-if="data && data[0]">
      <v-card-text class="text-h6 font-weight-medium mb-6">
        {{ title }}
      </v-card-text>
      <div v-for="(obj, i) in data" :key="i">
        <v-text-field
          color="secondary"
          class="pt-0 mx-4"
          filled
          dense
          :label="(obj.ad_size || obj.hole).toString()"
          v-model="obj.prebidconfigid"
          @input="$emit('update:data', data)"
        />
      </div>
    </div>
  </v-col>
</template>
<script>
export default {
  props: {
    title: String,
    data: Array,
  },
};
</script>
